<bb-page-header
	[icon]="'caret-square-right'"
	[title]="'ADUNITS' | translate"
	[filterConfig]="filterConfig"
	[allowCustomPreset]="allowCustomPreset"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<bb-adstats-blocks [statsDate]="statsDate"></bb-adstats-blocks>

<div class="body-column" ng-class="{'with-stats':globalStats}">
	<p *ngIf="!publication?.disablePositions" class="warning message"><i class="fa fa-warning"></i> {{ 'ADS_ARE_DISABLED' | translate }}</p>

	<div class="options">
		<div class="buttons">
			<bb-dropdown-button label="{{ 'CREATE_NEW' | translate }}">
				<ul>
					<li><a (click)="redirectToNew('preroll', $event)">{{ 'PREROLL' | translate }}</a></li>
					<li><a (click)="redirectToNew('postroll', $event)">{{ 'POSTROLL' | translate }}</a></li>
					<li [hasPublicationField]="'vmapAdUnit'"><a (click)="redirectToNew('vmap', $event)">{{ 'VMAP' | translate }}</a></li>
					<li><a (click)="redirectToNew('inarticle', $event)">{{ 'OUTSTREAM' | translate }}</a></li>
				</ul>
			</bb-dropdown-button>

			<a class="button" (click)="expandAdunits(!expandedAdUnits)"><i class="fas {{expandedAdUnits ? 'fa-caret-down' : 'fa-caret-right'}}"></i>
				<span>{{(expandedAdUnits ? 'COLLAPSE_ALL_AD_UNITS' : 'EXPAND_ALL_AD_UNITS') | translate }}</span>
			</a>
		</div>

		<bb-date-presets
			(onChanged)="datesChanged($event)"
			[icon]="'line-chart'"
			[presets]="adServicesService.datePresets"
			[time]="true"
			[minDate]="minDate"
			[minDateWarning]="'HELP.PROJECT_STATS_DATE_CORRECTED' | translate: {date: (minDate | date)}"
			[isLoading]="downloadReport">
			<a footer class="button download feedback" download (click)="downloadFromUrl()">
				<i class="fa fa-line-chart"></i>
				{{ 'DOWNLOAD_STATISTICS' | translate }}
			</a>
		</bb-date-presets>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell [hideSorting]="true" property="expand"></bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="positionType">{{ 'FORMAT' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="code" class="overflow">{{ 'CODE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="inventory">{{ 'INVENTORY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="inview">{{ 'IN_VIEW' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="views">{{ 'IMPRESSIONS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="placementRate">{{ 'PLACEMENT_RATE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell property="expand"><i (click)="expandRow(row, !row.expanded)" class="fas {{ row.expanded ? 'fa-caret-down' : 'fa-caret-right' }}"></i></bb-table-cell>
			<bb-table-cell property="id"><span [innerHTML]="row.data.id"></span></bb-table-cell>
+			<bb-table-cell optional property="positionType"><span [attr.title]="row.data.positionType">{{ row.data.positionType | uppercase | translate | lowercase }}</span></bb-table-cell>
			<bb-table-cell property="title" class="overflow"><span [attr.title]="row.data.title" [innerHTML]="row.data.title"></span></bb-table-cell>
			<bb-table-cell optional property="code" class="overflow"><span [attr.title]="row.data.code" [innerHTML]="row.data.code"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy"><span [attr.title]="row.data.createdBy" [innerHTML]="row.data.createdBy"></span></bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy"><span [attr.title]="row.data.updatedBy" [innerHTML]="row.data.updatedBy"></span></bb-table-cell>
			<bb-table-cell optional property="status"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell property="inventory"><span [innerHTML]="row?.inventory"></span></bb-table-cell>
			<bb-table-cell property="inview"><span [innerHTML]="row?.inview"></span></bb-table-cell>
			<bb-table-cell property="views"><span [innerHTML]="row?.views"></span></bb-table-cell>
			<bb-table-cell property="placementRate"><span [innerHTML]="row?.placementRate"></span></bb-table-cell>
			<bb-table-cell class="buttons">

				<a class="button" [routerLink]="['/adservices/adunits', row.data.id, 'general']">
					<i class="fa fa-edit"></i>
				</a><!--

				--><a class="button {{ row.outstream ? '' : 'disabled' }}" (click)="copyEmbedCode(row.data.code)">
					<i class="fa fa-code"></i>
				</a><!--

				--><a class="button" (click)="copyAdunit(row.data)">
					<i class="fa fa-copy"></i>
				</a><!--

				--><a class="button" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>

			</bb-table-cell>
			<bb-table-container *ngIf="row.expanded && row?.data?.positionType !== 'vmap'">
				<bb-table-header [configurable]="false">
					<bb-table-header-cell [hideSorting]="true" property="number"></bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="lineitemTitle" class="overflow">{{ 'LINEITEM_TITLE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="timeout">{{ 'TIMEOUT' | translate }}</bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="inventory">{{ 'INVENTORY' | translate }}</bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="views">{{ 'IMPRESSIONS' | translate }}</bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="fillRate">{{ 'FILL_RATE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="clickthroughRate">{{ 'CLICK_THROUGH_RATE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell class="lineitem-buttons"></bb-table-header-cell>
				</bb-table-header>
				<bb-table-row *ngFor="let lineItemId of row.data.assignedLineitems; let i = index">
					<bb-table-cell property="number">{{ i + 1 }}.</bb-table-cell>
					<bb-table-cell property="lineitemTitle" class="overflow">{{ assignedLineItems[lineItemId]?.title }}</bb-table-cell>
					<bb-table-cell property="timeout">{{ assignedLineItems[lineItemId]?.timeout }}</bb-table-cell>
					<bb-table-cell property="inventory"><span [innerHTML]="assignedLineItems[lineItemId]?.inventory"></span></bb-table-cell>
					<bb-table-cell property="views"><span [innerHTML]="assignedLineItems[lineItemId]?.views"></span></bb-table-cell>
					<bb-table-cell property="fillRate"><span [innerHTML]="assignedLineItems[lineItemId]?.fillRate"></span></bb-table-cell>
					<bb-table-cell property="clickthroughRate"><span [innerHTML]="assignedLineItems[lineItemId]?.clickthroughRate"></span></bb-table-cell>
					<bb-table-cell class="lineitem-buttons">
						<a class="button" [routerLink]="['/adservices/lineitems', lineItemId, 'settings']">
							<i class="fa fa-edit"></i>
						</a>
					</bb-table-cell>
				</bb-table-row>
			</bb-table-container>
		</bb-table-row>

	</bb-table-container>

	<bb-table-pager></bb-table-pager>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_LINE_ITEMS_FOUND' | translate }}</div>

</div>
